export default __webpack_public_path__ + "images/cb3aeb8ee2ad84a1aa59ed59ba8f1b88-glasses.png";